import {
  GetBillingCycleInvoicesResponseSchema,
  type GetBillingCycleInvoicesResponse,
} from '@vy/api-definition';
import { withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { BILLING_CYCLE_INVOICES_DEFAULT_PAGE_SIZE } from './use-billing-cycle-invoices-consts';
import { queryKeys } from '../../../services/query-key/query-keys';

type UseBillingCycleInvoicesPayload = Parameters<
  ReturnType<typeof getPrivateApi>['getBillingCycleInvoices']
>[0];

export function useBillingCycleInvoices(
  payload: UseBillingCycleInvoicesPayload = {},
  options?: CustomUseQueryOptions<GetBillingCycleInvoicesResponse>,
) {
  return useQuery(
    queryKeys.billingCycleInvoices(...Object.values(payload)),
    async ({ signal }) => {
      const invoicesApi = getPrivateApi();
      const getBillingCycleInvoicesResponse = await invoicesApi.getBillingCycleInvoices(
        {
          page: withDefault(payload.page, 0),
          pageSize: withDefault(payload.pageSize, BILLING_CYCLE_INVOICES_DEFAULT_PAGE_SIZE),
          ...payload,
        },
        { signal },
      );

      return GetBillingCycleInvoicesResponseSchema.parse(getBillingCycleInvoicesResponse);
    },
    { keepPreviousData: true, ...options },
  );
}
